
export default function updateEmail() {
    return {
       
        passedSessionId: '',
        passedEmail: '',
        confirmEmail: '',
        isEmail: true,
        errorisEmail:'',
        isconfirmEmail: true,
        errorconfirmEmail:'',
        message: '',
        isMessage: true,
        isSubmitting:false,
        resetData() {

            this.passedEmail = "";
            this.confirmEmail = "";
            this.message = "";
            this.isEmail = true;
            this.isconfirmEmail = true;
        },
        isValidEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        },
        updateEmailData() {
            this.isSubmitting = true;
            if (this.passedEmail == "") {
                this.isEmail = false;
                this.errorisEmail = "Please enter email."
                this.message = "";
                this.isMessage = true;
                this.isSubmitting = false;
            } else if (!this.isValidEmail(this.passedEmail)) {
                this.isEmail = false;
                this.errorisEmail = "Please enter valid email."
                this.message = "";
                this.isMessage = true;
                this.isSubmitting = false;
            }
            else {
                this.isEmail = true;
                this.errorisEmail = "";
            }
            if (this.confirmEmail =="") {
                this.isconfirmEmail = false;
                this.errorconfirmEmail = "Please enter confirm email."
                this.message = "";
                this.isMessage = true;
                this.isSubmitting = false;
            }
            else if (!this.isValidEmail(this.confirmEmail)) {
                this.isconfirmEmail = false;
                this.errorconfirmEmail = "Please enter valid confirm email."
                this.message = "";
                this.isMessage = true;
                this.isSubmitting = false;
            }
            else {
                this.isconfirmEmail = true;
                this.errorconfirmEmail = "";
            }
            if (this.confirmEmail != this.passedEmail) {

                this.isconfirmEmail = false;
                this.errorconfirmEmail = "Email addresses are not matching."
                this.message = "";
                this.isMessage = true;
                this.isSubmitting = false;
            }
            else {
                this.isconfirmEmail = true;
                this.errorconfirmEmail = "";
            }
            if (this.isEmail && this.isconfirmEmail) {
                fetch('/api/UserAPI/UpdateEmail', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        
                        Email: this.passedEmail,
                        OldEmail:document.getElementById('hdnEmail').value,
                    })
                })
                    .then(response => {
                        if (response.ok) {
                            return response.json()
                        }
                    }).then(response => {

                        if (response.isSuccess) {
                            this.isMessage = true;
                            this.message = "Email updated successfully."
                           
                        } else {
                            this.isMessage = false;
                            this.message = "An unknown error has occurred. Please try again later."
                        }
                        this.isSubmitting = false;
                    });
            }

        },

        init() {
           
            this.passedEmail = document.getElementById('hdnEmail').value
            this.confirmEmail = document.getElementById('hdnEmail').value

        }
    }
}